import {
  LanguageChangeListenerCallback,
  LanguageIdentifier,
  LanguageInterface,
  NamespaceIdentifier,
  StateInterface,
  TranslationChangeListenerCallback,
  TranslationFlat,
  TranslationResolverInterface,
} from "..";

/**
 * The global state of the i18n module.
 */
export class I18NState implements StateInterface {
  private static instance: I18NState = new I18NState();
  public language: string = "en";
  private _languages: Record<LanguageIdentifier, LanguageInterface> = {};
  private _translations: Record<
    LanguageIdentifier,
    Record<NamespaceIdentifier, TranslationFlat>
  > = {};
  public namespacesInUse: Set<string> = new Set();
  public namespacesResolving: Record<NamespaceIdentifier, boolean> = {};
  private _translationResolver: TranslationResolverInterface[] = [];
  public languageChangeListener: Set<LanguageChangeListenerCallback> =
    new Set();
  public translationChangeListener: Set<TranslationChangeListenerCallback> =
    new Set();

  constructor(
    language: string = "en",
    translations: Record<
      LanguageIdentifier,
      Record<NamespaceIdentifier, TranslationFlat>
    > = {}
  ) {
    // do not create a new instance, if one already exists
    if (I18NState.instance) {
      I18NState.instance.language = language;
      I18NState.instance._translations = translations;
      return I18NState.instance;
    }

    // initialize the instance
    this.language = language;
    this._translations = translations;

    // set the initialized instance to the static instance
    I18NState.instance = this;
    return I18NState.instance;
  }

  static getInstance(): I18NState {
    if (!I18NState.instance) {
      // initialize the instance if it does not exist
      new I18NState();
    }
    return I18NState.instance;
  }

  /**
   * Gets the languages.
   */
  get languages(): Record<LanguageIdentifier, LanguageInterface> {
    return this._languages;
  }

  /**
   * Gets the translations.
   */
  get translations(): Record<
    LanguageIdentifier,
    Record<NamespaceIdentifier, TranslationFlat>
  > {
    return this._translations;
  }

  /**
   * Gets the translation resolvers.
   */
  get translationResolver(): TranslationResolverInterface[] {
    return this._translationResolver;
  }

  addLanguage(language: LanguageInterface): void {
    this._languages[language.key] = language;
  }

  addTranslation(
    key: NamespaceIdentifier,
    translation: Record<string, TranslationFlat>
  ): void {
    this._translations[key] = translation;
  }

  addTranslationResolver(resolver: TranslationResolverInterface): void {
    this._translationResolver.push(resolver);
  }
}
